import { render, staticRenderFns } from "./AISummaryCard.vue?vue&type=template&id=215fcbc6"
import script from "./AISummaryCard.vue?vue&type=script&lang=js"
export * from "./AISummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports